module.exports = __webpack_public_path__ + "media/images/emblems/Bedretto-coat_of_arms-219f9af53c4d3579cb11ab7e6670e07d.svg";